var searchFiltersTemplate = require('templates/searchFilters.hbs');
var AriesComponent = require('libs/aries-component');
var PageTakeover = require('libs/pageTakeover');
var ResponsiveUtils = require('utils/responsiveUtils');
var localStorage = require('local-storage-fallback');
var PubSub = require('libs/pub-sub');
var $ = require('jquery');
var Constants = require('libs/constants');
var Config = require('libs/config');
var Loader = require('libs/loader');
var Cookies = require('libs/cookies');

PubSub.register(AriesComponent.extend({
  type: 'searchFilters',
  template: {
    'searchFilters': searchFiltersTemplate
  },
  state: {},
  selectionOrder: [],
  selectedOrder: [],
  subscribe: {
    'HIDE_FILTERS_PANEL': 'hideSortAndFilters',
    'SHOW_BRAND_FILTER' : 'openSortAndFilters',
    'SRP_VIEW_CHANGED': 'srpViewChanged'
  },
  events: {
    'click .cta-sort-and-filter': 'openSortAndFilters',
    'keypress .cta-sort-and-filter': 'openSortAndFilters',
		'click .m-dropdown': 'dropDownMouseHandler',
		'keypress .m-dropdown': 'dropKeyBoradHandler',
		'blur .m-dropdown': 'onMenuBlurHandler',
    'click .m-dropdown .m-dropdown-option': 'onMemuItemSelected',
    'click .cta-hide-sort-and-filter': 'hideSortAndFilters',
    'keypress .cta-hide-sort-and-filter': 'hideSortAndFiltersKey',
    'change .cta-filter': 'onFilterSelected',
		'change .cta-filter-desktop': 'onFilterSelected',
    'change .cta-sort': 'onSortBySelected',
    'click .l-filters .js-accordion-toggle': 'onAccordionOpen',
    'keypress .l-filters .js-accordion-toggle': 'adaAccordionOpen',
    'click .cta-reset': 'resetForm',
    'click .js-brand-icon' : 'brandIconClickHandler',
    'keypress .js-brand-icon' : 'brandIconKeypressHandler',
    'click .select-all-category-labels' : 'selectAllCategoryLabels',
    'click .clear-all-category-labels' : 'clearAllCategoryLabels',
    'click .m-dropdown-label':'dropDownMouseLabelHandler',
    'keypress .m-dropdown-label':'dropDownKeyBoardLabelHandler',
		'click .m-dropdown .m-dropdown-option': 'onFilterDropdownMenuItemSelected',
    'click .l-pill': 'submitSuggestedFilterPayload',
    'click .available-hotels, .toggle-full-price': 'toggleAvailableFilter',
    'keydown .js-tab-toggle':'changeTabs',
    'keydown .all-filter-overlay': 'modalKeyPress',
    'keydown .l-tabcontainer-content': 'modalpanelKeyPress',
    'blur .m-dropdown-option-v2':'closeDropdownOnBlur',
    'keydown .m-dropdown-label-v2':'closeDropdownOnLabelBlur',
    'keydown .cta-apply':'filterApplyBtnOnBlur'
  },
  options: {
    'SORT_AND_FILTER_MODEL': '.js-sort-and-filter',
    'DISPLAY_ONLY_FORM': '.js-form-display-only',
    'SUBMIT_FORM': '.js-submit-form',
    'CTA_FILTERS': '.cta-hide-sort-and-filter',
    'SORT_AND_FILTER_FROM': '.js-sort-and-filter-form',
    'SUGGESTED_FILTER_FORM': '.suggested-filter-form',
    'TYPE_A': 'A'
  },
  bindEvents: function() {
    var _self = this;
    _self.isSearchFiltersEnabled = true;
    var $submitForm = _self.$el.find(_self.options.SUBMIT_FORM);
    _self.$currentFilterElm = $();
    _self.initResponsiveUtils();
				_self.initTabs();
				_self.isMobile = false;
				_self.initDeviceMode();
    _self.refinedSearchUrl = _self.$el.data('refine-search-url');

    _self.filterType = _self.options.TYPE_A;
    if (_self.$el.data() && _self.$el.data().type) {
      _self.filterType = _self.$el.data().type;
    }
    // _self.pubsub.publish('SEARCH_FILTER_TYPE', [_self.filterType]);

    if (typeof(_self.initialAppliedFilters) !== 'object') {
      _self.$el.parents('.mi-sub-section').css({position: 'relative'});
      _self.initialAppliedFilters = _self.serializeForm();
      $.each($submitForm[0].elements, function(index, input) {
        if( _self.initialAppliedFilters[input.name] && _self.initialAppliedFilters[input.name].length )
          input.value = JSON.stringify(_self.initialAppliedFilters[input.name])
      });
      $submitForm.find('[name="filter"]').val(_self.initialAppliedFilters.filter);
      _self.selectedOrder = _self.$el.data('filtertags') ? _self.$el.data('filtertags') : [];
      $submitForm.find('[name="selectionOrder"]').val(JSON.stringify(_self.selectedOrder));
    } else {
      this.$el.parents('.mi-sub-section').css({position: 'static'});
    }

    if( $('#points-list li').length ) {
      var locale = $('#points-list').data('locale').toLowerCase();
      $('#points-list li').each(function(i, ele) {
        if(i>0) {
          var pointsText = $(ele).find('label').text();
          var pointsArray = pointsText.split(' ');
          if(locale == 'pt' || locale == 'es' || locale == 'br' || locale == 'it' || locale == 'de') {
            var startLimit = pointsArray[0].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
            var endLimit = pointsArray[2].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
          } else if(locale == 'fr' || locale == 'ru') {
            var startLimit = pointsArray[0].toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
            var endLimit = pointsArray[2].toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
          } else {
            var startLimit = pointsArray[0].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            var endLimit = pointsArray[2].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
          }
          pointsArray[0] = startLimit;
          if( i < ($('#points-list li').length - 1) ){
            pointsArray[2] = endLimit;
          }
          var updatedPoints = pointsArray.join(' ');
          $(ele).find('label').text(updatedPoints);
        }
      });
    }
    
    if( this.$el.find(this.options.SORT_AND_FILTER_MODEL).is(':visible') )
      this.pubsub.publish('HIDE_STICKY_SEARCH_FORM');
  },
  /**
  * This function is used to initiate responsive utils
  */
  initResponsiveUtils: function() {
    this.responsiveUtils = ResponsiveUtils.create({
      // orientationChangeEventHandler: _.bind(this.orientationChangeEventHandler, this),
      resizeEventHandler: _.bind(this.resizeEventHandler, this)
    });
    this.responsiveUtils.init();
  },

  /**
  * ADA functionality
  * This function is used to trap focus inside filter modal window.
  */
  modalKeyPress: function(evt) {
    
    const  focusableElements =
    'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';
    const modal = document.querySelector('.all-filter-overlay');

    const firstFocusableElement = modal.querySelectorAll(focusableElements)[1];
    const focusableContent = modal.querySelectorAll(focusableElements);
    const lastFocusableElement = focusableContent[focusableContent.length - 1];

    let isTabPressed = evt.key === 'Tab' || evt.keyCode === 9;

    if (!isTabPressed) {
      return;
    }

    if (evt.shiftKey) { // if shift key pressed for shift + tab combination
      if (document.activeElement === firstFocusableElement) {
        lastFocusableElement.focus(); // add focus for the last focusable element
        evt.preventDefault();
      }
    } else { // if tab key is pressed
      if (document.activeElement === lastFocusableElement) { // if focused has reached to last focusable element then focus first focusable element after pressing tab
        firstFocusableElement.focus(); // add focus for the first focusable element
        evt.preventDefault();
      }
    }
  },

  /**
  * ADA functionality
  * This function is used to set focus on next tab heading.
  * Triggered on tab press on tab panel
  */
  modalpanelKeyPress: function(evt) {
    let tabPanel = $(evt.currentTarget).attr("id").replace('tab-','');
    const  focusableElements =
    'button, [href], input:not([tabindex="-1"]), select, textarea, [tabindex]:not([tabindex="-1"])';
    const focusableContent = $(evt.currentTarget).find(focusableElements);
    const firstFocusableElement = focusableContent[0];
    const lastFocusableElement = focusableContent[focusableContent.length - 1];
    if (!evt.shiftKey && evt.which == 9) {
      if (document.activeElement === lastFocusableElement) { 
        if ($(`#label-${tabPanel}`).next().length > 0) {
          $(`#label-${tabPanel}`).next().find('.js-tab-toggle').focus();
        } else {
          $('.cta-apply').focus();
        }
        evt.preventDefault();
      }
      if (document.activeElement.type === 'radio' && document.activeElement.name === lastFocusableElement.name) {
        if ($(`#label-${tabPanel}`).next().length > 0) {
          $(`#label-${tabPanel}`).next().find('.js-tab-toggle').focus();
        } else {
          $('.cta-apply').focus();
        }
        evt.preventDefault();
      }
    }
    if (evt.shiftKey && evt.which == 9) {
      if (firstFocusableElement.type === 'radio' ) {
        $(`#label-${tabPanel}`).find('.js-tab-toggle').focus();
        evt.preventDefault();
      }
      if (document.activeElement === firstFocusableElement) {
        $(`#label-${tabPanel}`).find('.js-tab-toggle').focus();
        evt.preventDefault();
      }
    }
  },

  /**
  * ADA functionality
  * This function is used to focus first focusable element in tab panel.
  * Triggered on tab press on tab heading
  */
  changeTabs: function(evt) {
    var tabPanel = $(evt.currentTarget).attr('aria-controls');
    var previousTab = tabPanel.replace('tab-','');
    const  focusableElements =
    'button, [href], input:not([tabindex="-1"]), select, textarea, [tabindex]:not([tabindex="-1"])';
    const focusableContent = $(`#${tabPanel}`).find(focusableElements);
    const firstFocusableElement = focusableContent[0];
    if (!evt.shiftKey && evt.which == 9 && $(evt.currentTarget).hasClass('is-active')) {
      if (firstFocusableElement.type === 'radio' ) {
        const categoryName = firstFocusableElement.name;
        $(`input:radio[name=${categoryName}]:checked`).focus();
      } else {
        firstFocusableElement.focus();
      }
      evt.preventDefault();
    }
    if (evt.shiftKey && evt.which == 9) {
      if ($(`#label-${previousTab}`).prev().length > 0) {
        if($(`#label-${previousTab}`).prev().find('.js-tab-toggle').length > 0 && $(`#label-${previousTab}`).prev().find('.js-tab-toggle').hasClass('is-active')){
          const prevTabPanel = $(`#label-${previousTab}`).prev().find('.js-tab-toggle').attr('aria-controls');
          const prevFocusableContent = $(`#${prevTabPanel}`).find(focusableElements);
          const lastFocusableElement = prevFocusableContent[prevFocusableContent.length - 1];
          if (lastFocusableElement.type === 'radio' ) {
            const categoryName = lastFocusableElement.name;
            $(`input:radio[name=${categoryName}]:checked`).focus();
          } else {
            lastFocusableElement.focus();
          }
        } else {
          $(`#label-${previousTab}`).prev().find('.js-tab-toggle').focus();
        }
        evt.preventDefault();
      }
    }
    if ($(`#label-${previousTab}`).next().length <= 0 && !evt.shiftKey && evt.which == 9 && !$(evt.currentTarget).hasClass('is-active')) {
      $('.cta-apply').focus();
      evt.preventDefault();
    }
  },

  /**
  * ADA functionality
  * This function is used to focus last focusable element in tab panel.
  * Triggered on shift + tab key press on filter apply button.
  */
  filterApplyBtnOnBlur: function(evt) {
    if (evt.shiftKey && evt.which == 9) {
      if ($('.l-tabcontainer-tabs').length > 0 && $('.l-tabcontainer-tabs').find('.l-tabcontainer-header:last-child').length > 0 && $('.l-tabcontainer-tabs').find('.l-tabcontainer-header:last-child').find('.js-tab-toggle').length > 0) {
        if (!$('.l-tabcontainer-tabs').find('.l-tabcontainer-header:last-child').find('.js-tab-toggle').hasClass('is-active')) {
          $('.l-tabcontainer-tabs').find('.l-tabcontainer-header:last-child').find('.js-tab-toggle').focus();
          evt.preventDefault();
        }
      }
    }
  },

  /**
  * This function is used to remove pagetakeover styling on resize event.
  */
  resizeEventHandler: function() {
    var $displayForm = this.$el.find(this.options.DISPLAY_ONLY_FORM);
  },
  
  /**
   * Create the Div Element which helps block the screen
   */
  initScreenBlock: function() {
    this.$subSection = this.$el.parents('.mi-sub-section');
    this.$subSection.css({position: 'static'});
  },

  /**
   * CTA handler for Filter Button
   */
  openSortAndFilters: function(event) {
    var charCode = event.which || event.key.charCodeAt(0),
    $currentFilter;

    this.$currentFilterElm = $(event.currentTarget);
    $currentFilter = this.$currentFilterElm.data('target');

    this.initScreenBlock();
    if( ('keypress' === event.type && (13 === charCode || 32 === charCode) ) || 'click' === event.type ) {
      event.preventDefault();
      this.showSortAndFilters();
      //this.pubsub.publish('ADJUST_MENU_HEIGHT');
      if($currentFilter){
        if(this.$el.find('div.js-accordion-toggle.open').length > -1 && this.$el.find('div.js-accordion-toggle.open').data('accordion') === $currentFilter) {
          //do nothing
        }else{
          this.$el.find('div.js-accordion-toggle.open').trigger('click');
          this.$el.find('.js-accordion-toggle[data-accordion="'+$currentFilter+'"]').trigger('click');
        }

        if(this.$el.find('a.js-tab-toggle.is-active').length > -1 && this.$el.find('a.js-tab-toggle.is-active').data('code') === $currentFilter){
            //do nothing
        } else{
            this.$el.find('a.js-tab-toggle.is-active').trigger('click');
            this.$el.find('.js-tab-toggle[data-code="'+$currentFilter+'"]').trigger('click');
        }
      }
      this.pubsub.publish('ADJUST_MENU_HEIGHT');
      var ctHeaderBanner = Cookies.readCookie('ctBannerCounter');
      if(ctHeaderBanner <= 3 ) {
        $('.l-tabcontainer-content.is-active').addClass('tab-banner-height');
      } else {
        $('.l-tabcontainer-content.is-active').removeClass('tab-banner-height');
      }
      this.$el.find('.cta-hide-sort-and-filter').focus();
    }
  },

  /**
   * Handler for Sort & Filter CTA
   */
  showSortAndFilters: function() {
    var _self=this;
    if(_self.$el.find('.cta-sort-and-filter').data('searchkey')){
      var isTileDisplayed=false;
      _self.$el.find('.cta-sort-and-filter').parent('.l-filter-container').removeClass('l-display-block').addClass('l-display-none');
      _self.pubsub.publish('TOGGLE_PAGE_HEADER',[isTileDisplayed]);
      _self.pubsub.publish('TOGGLE_HOTEL_DIRECTORY_RESULT_SUMMARY',[isTileDisplayed]);
      _self.pubsub.publish('TOGGLE_HOTEL_DIRECTORY_REGION_NAV',[isTileDisplayed]);
      _self.pubsub.publish('TOGGLE_HOTEL_DIRECTORY',[isTileDisplayed]);
      _self.pubsub.publish('TOGGLE_HOTEL_DIRECTORY_CROSS_LINKS',[isTileDisplayed]);
      _self.pubsub.publish('TOGGLE_CONNECT_US',[isTileDisplayed]);
      _self.$el.find('.cta-sort-and-filter').addClass('l-display-none');
      $(window).scrollTop(0);
      _self.$el.find(_self.options.SORT_AND_FILTER_MODEL).removeClass('l-display-none');
      _self.$el.find(_self.options.CTA_FILTERS).attr('aria-expanded', 'true');    
      _self.pubsub.publish('SEARCH_FILTER_VISIBLE');

      if (_self.filterType !== _self.options.TYPE_A) {
        _self.$el.find(_self.options.SORT_AND_FILTER_MODEL).addClass('modal-open');
        $('body').css('overflow-y', 'hidden');

        $(document).on('click.filter_modal', function(e) {
          if (_self.$el.find(_self.options.SORT_AND_FILTER_MODEL).hasClass('modal-open')) {
            if (!$(e.target).parents('.modal-open').length && (!$(e.target).hasClass('cta-sort-and-filter') && !$(e.target).parents('.cta-sort-and-filter').length)) {
              _self.hideSortAndFilters();
            }
          }
        });
      }
      this.toggleFooterFilter(false);
    } else{
      _self.pubsub.publish('HIDE_STICKY_SEARCH_FORM');
      // this.pubsub.publish('STICKY_SCROLL_TOP');
      $(window).scrollTop(0);
      _self.$el.find(_self.options.SORT_AND_FILTER_MODEL).removeClass('l-display-none');
      _self.$el.find(_self.options.CTA_FILTERS).attr('aria-expanded', 'true');    
      _self.pubsub.publish('SEARCH_FILTER_VISIBLE');
      if (_self.filterType !== _self.options.TYPE_A) {
        _self.$el.find(_self.options.SORT_AND_FILTER_MODEL).addClass('modal-open');
        $('body').css('overflow-y', 'hidden');

        $(document).on('click.filter_modal', function(e) {
          if (_self.$el.find(_self.options.SORT_AND_FILTER_MODEL).hasClass('modal-open')) {
            if (!$(e.target).parents('.modal-open').length && (!$(e.target).hasClass('cta-sort-and-filter') && !$(e.target).parents('.cta-sort-and-filter').length)) {
              _self.hideSortAndFilters();
            }
          }
        });
      }
		}
    _self.pubsub.publish('TOGGLE_FOOTER_FILTER', [false]);
    if($('.hide-suggested-filters').length){
      $('.hide-suggested-filters').css('visibility','visible');
      $('.all-filter-visibility').css('visibility','hidden');
    }
  },

  /**
   * Hide the Sort & Filter Model
   */
  hideSortAndFilters: function() {
    var _self=this;
    this.$el.parents('.mi-sub-section').css({position: 'relative'});
    if(!_.isEqual(_self.initialAppliedFilters,_self.serializeForm())) {
      _self.refresh(_self.initialAppliedFilters, function() {
        window.$(document).trigger('GLOBAL_ELEMENTS_REINIT.mi-foundation');

        var $submitForm = _self.$el.find(_self.options.SUBMIT_FORM);
        $.each($submitForm[0].elements, function(index, input) {
          if( _self.initialAppliedFilters[input.name] && _self.initialAppliedFilters[input.name].length )
            input.value = JSON.stringify(_self.initialAppliedFilters[input.name])
        });
        _self.selectedOrder = _self.$el.data('filtertags') ? _self.$el.data('filtertags') : [];
      }, function(error) {
        window.location.replace(_self.$el.data(Constants.FILTER.ERROR_REDIRECT_URI));
      });
    }
    if(_self.$el.find('.cta-sort-and-filter').data('searchkey')){
      var isTileDisplayed=true;
      _self.$el.find('.cta-sort-and-filter').parent('.l-filter-container').removeClass('l-display-none').addClass('l-display-block');
      _self.pubsub.publish('TOGGLE_PAGE_HEADER',[isTileDisplayed]);
      _self.pubsub.publish('TOGGLE_HOTEL_DIRECTORY_RESULT_SUMMARY',[isTileDisplayed]);
      _self.pubsub.publish('TOGGLE_HOTEL_DIRECTORY_REGION_NAV',[isTileDisplayed]);
      _self.pubsub.publish('TOGGLE_HOTEL_DIRECTORY',[isTileDisplayed]);
      _self.pubsub.publish('TOGGLE_HOTEL_DIRECTORY_CROSS_LINKS',[isTileDisplayed]);
      _self.pubsub.publish('TOGGLE_CONNECT_US',[isTileDisplayed]);
      _self.$el.find('.cta-sort-and-filter').removeClass('l-display-none');
      _self.$el.find(_self.options.SORT_AND_FILTER_MODEL).addClass('l-display-none');
      _self.$el.find(_self.options.CTA_FILTERS).attr('aria-expanded', 'false');    
      _self.pubsub.publish('SEARCH_FILTER_VISIBLE');
      if (_self.filterType !== _self.options.TYPE_A) {
        _self.$el.find(_self.options.SORT_AND_FILTER_MODEL).addClass('modal-open');
        $('body').css('overflow-y', 'hidden');

        $(document).on('click.filter_modal', function(e) {
          if (_self.$el.find(_self.options.SORT_AND_FILTER_MODEL).hasClass('modal-open')) {
            if (!$(e.target).parents('.modal-open').length && (!$(e.target).hasClass('cta-sort-and-filter') && !$(e.target).parents('.cta-sort-and-filter').length)) {
              _self.hideSortAndFilters();
            }
          }
        });
      }
      this.toggleFooterFilter(true);
    }else{
      if (_self.filterType !== _self.options.TYPE_A) {
        $('body').css('overflow-y', 'visible');
        $(document).off('click.filter_modal');
        _self.$el.find(_self.options.SORT_AND_FILTER_MODEL).removeClass('modal-open');
      }

      _self.pubsub.publish('SEARCH_FILTER_HIDDEN');
      _self.$el.find(this.options.SORT_AND_FILTER_MODEL).addClass('l-display-none');
      _self.$el.find(this.options.CTA_FILTERS).attr('aria-expanded', 'false');
      _self.pubsub.publish('TOGGLE_STICKY_PANEL');
    }
    _self.pubsub.publish('TOGGLE_FOOTER_FILTER', [true]);
    _self.$currentFilterElm.focus();
    if($('.hide-suggested-filters').length){
      $('.hide-suggested-filters').css('visibility','hidden');
      $('.all-filter-visibility').css('visibility','visible');
    }
  },
  hideSortAndFiltersKey: function(evt){
    var charCode = evt.charCode || evt.which;
    if( 13 === charCode ) {
      this.hideSortAndFilters();
    }
  },
  	/**
	 * Dropdown menu mouse event handler
	 */
	dropDownMouseHandler: function(evt) {
		if( !$(evt.target).hasClass('m-dropdown-option') )
			this.openDropDown(evt.currentTarget);
	},

  	/**
	 * Dropdown label mouse event handler
	 */
	dropDownMouseLabelHandler: function(evt) {
    if( !$(evt.target.nextElementSibling).hasClass('in-focus') ) {
      $('.m-dropdown').removeClass('in-focus');
    }
		if( !$(evt.target.nextElementSibling).hasClass('m-dropdown-option') )
			this.openDropDown(evt.target.nextElementSibling);
	},

  closeDropdownOnBlur: function(evt) {
    if(!$(evt.currentTarget).next().is(':visible')) {
      $('.m-dropdown').removeClass('in-focus');
    }
	},

  closeDropdownOnLabelBlur: function(evt) {
    if (evt.shiftKey && evt.which == 9) {
      $('.m-dropdown').removeClass('in-focus');
    }
	},
	
	/**
	 * Dropdown menu keyborad event handler
	 */
	dropKeyBoradHandler: function(evt) {
    var charCode = evt.charCode || evt.which;
		if( 13 === charCode || 32 === charCode ) {
      evt.preventDefault();
			if( $(evt.target).hasClass('m-dropdown-option') )
				this.onMemuItemSelected({currentTarget: evt.target});
			else
				this.openDropDown(evt.currentTarget);
		}	
	},

  	/**
	 * Dropdown label keypress event handler
	 */
	dropDownKeyBoardLabelHandler: function(evt) {
    var charCode = evt.charCode || evt.which;
		if( 13 === charCode || 32 === charCode ) {
      if( !$(evt.target.nextElementSibling).hasClass('in-focus') ) {
        $('.m-dropdown').removeClass('in-focus');
      }
      if( !$(evt.target.nextElementSibling).hasClass('m-dropdown-option') )
        this.openDropDown(evt.target.nextElementSibling);
    }
	},

	/**
	 * Event handler for sort dropdown value selection
	 */
	onMemuItemSelected: function(evt) {
		var $menuOption = $(evt.currentTarget);
		if( !$menuOption.hasClass('current-value') ) {
			var paramName = $menuOption.data('bucket');
			var value = $menuOption.data('value');
      this.setFilterBy(paramName, value);
      this.submitSortBy();
		}
		this.hideMenu($menuOption);
	},

	/**
	 * On Blur Menu Event Handler, helps hide the menu when focus is lost
	 */
	onMenuBlurHandler: function(evt) {
		if(!evt.relatedTarget || !$(evt.currentTarget).find(evt.relatedTarget).length){
      if(!$(evt.relatedTarget).hasClass('m-dropdown-label')){
        this.hideMenu(evt.currentTarget);
      }
    }
  },
  
  /**
	 * Hide the menu based on any given item in the menu or menu it self
	 */
	hideMenu: function(menu) {
		var $menu = $(menu);
		if( !$menu.hasClass('.m-dropdown') )
    {
      $menu = $menu.closest('.m-dropdown');
    }
    $menu.removeClass('in-focus');
	},

  /**
	 * Open the menu
	 */
	openDropDown: function(menu) {
		var $menu = $(menu);
		var $list = $menu.find('.m-dropdown-list');

		if( $menu.hasClass('in-focus') )
			$menu.removeClass('in-focus');
		else {
			$menu.addClass('in-focus');
			$list.find('.m-dropdown-option').first().focus();
		}
  },
  
  /**
   * CTA Handler for On Change Search Filter
   */
  onFilterSelected: function(evt) {
    evt.preventDefault();
    var input = evt.currentTarget;
    if ($(input).data('type') != 'rangeFilter') {
      if( input.checked ) {
        this.selectedOrder.push(
          {'bucketName': input.name, 'code': input.value, 'label': this.$el.find('[for="' + input.id + '"]').text() }
        );
      } else {
        this.selectedOrder = _.filter(this.selectedOrder, function(item) {
          return !(item.bucketName === input.name && item.code === input.value);
        });
      }
    }
    this.updateFilters();
  },
  /**
   * CTA handler for drop-down menu handler
   */
  setFilterBy: function(sortBy, index) {
			var _self = this;
    var $elements = $(this.$el.find(this.options.DISPLAY_ONLY_FORM)[0].elements);

				if ($elements.filter('[data-device="mobile"]').length || $elements.filter('[data-device="desktop"]').length) {
					if (_self.isMobile) {
						$elements.filter('[data-type="rangeFilter"][name="' + sortBy + '"][value="' + index + '"]').prop("checked", true);
					} else {
						$elements.filter('[data-type="rangeFilter"][name="tab-' + sortBy + '"][value="' + index + '"]').prop("checked", true);
					}
				} else {
					$elements.filter('[data-type="rangeFilter"][name="' + sortBy + '"][value="' + index + '"]').prop("checked", true);
				}

    $elements.filter('[data-availability-filter=' + '"' + sortBy + '"]').each(function(index, item) {
      $(item).attr("data-checked",false);
    });
    $elements.filter('[data-availability-filter=' + '"' + sortBy + '"][value="' + index + '"]').attr("data-checked", true);
    if (sortBy === "distanceUnit") {
      this.$el.find('[name=' + sortBy + ']').val(index);
    }
  },

  /**
   * CAT handler for sort by value selected
   */
  onSortBySelected: function(evt) {
    evt.preventDefault();
    var input = evt.currentTarget;
    if( input.checked ) {
      var location = window.location;
      var queryParams = {};
      if( location.search ) {
        location.search.substr(1).split('&').forEach(function findParam(param) {
          var params = param.split('=');
          queryParams[params[0]] = params[1]
        })
      }
      queryParams[input.name] = input.value;
      
      var filterDropdownUrl = window.location.origin + this.refinedSearchUrl + '?';
      var userAgentDetails = window.navigator.userAgent;
      var ieBrowser = userAgentDetails.indexOf("MSIE ");

      if (ieBrowser > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./))  // If Internet Explorer, return version number
      {
        var actualUrl = window.location.href;
        var refinedUrl = '';
        for (let i = 0; i < Object.entries(queryParams).length; i++) {
          refinedUrl = this.setIEUrl(actualUrl, Object.entries(queryParams)[i][0], Object.entries(queryParams)[i][1]);
          actualUrl = refinedUrl;
        }
        window.location = refinedUrl;
      }
      else  // If another browser, return 0
      {
        var filterurl = new URL(filterDropdownUrl);
        for (let i = 0; i < Object.entries(queryParams).length; i++) {
          filterurl.searchParams.set(Object.entries(queryParams)[i][0], Object.entries(queryParams)[i][1]);
        }
        window.location = filterurl.href;
      }
    }
  },

  /**
   * Serialize Form the inputs form
   */
  serializeForm: function() {
    var $elements = $(this.$el.find(this.options.DISPLAY_ONLY_FORM)[0].elements);
    var payload = { facets: [], rangeFilter: []}
    var facets = {}, rangeFilter = {};
				var _self = this;
				if ($elements.filter('[data-device="mobile"]').length || $elements.filter('[data-device="desktop"]').length) {
					if (_self.isMobile) {
						$elements.filter('[data-device="mobile"][data-type="facets"]:checked').each(function(index, input) {
							if( !facets[input.name] )
									facets[input.name] = [];
							facets[input.name].push(input.value);
						});
					} else {
						$elements.filter('[data-device="desktop"][data-type="facets"]:checked').each(function(index, input) {
							if( !facets[input.name] )
									facets[input.name] = [];
							facets[input.name].push(input.value);
						});
					}
				} else {
					$elements.filter('[data-type="facets"]:checked').each(function(index, input) {
            if( !facets[input.name] )
              facets[input.name] = [];
            facets[input.name].push(input.value);
          });
				}

    Object.keys(facets).forEach(function(value) {
      var item = {};
      item[value] = facets[value];
      payload.facets.push(item);
    })

				if ($elements.filter('[data-device="mobile"]').length || $elements.filter('[data-device="desktop"]').length) {
					if (_self.isMobile) {
						$elements.filter('[data-device="mobile"][data-type="rangeFilter"]:checked').each(function(index, input) {
							if( !rangeFilter[input.name] )
									rangeFilter[input.name] = [];
	
							if( input.value ) {
									rangeFilter[input.name].push(input.value);
							}
						});
					} else {
						$elements.filter('[data-device="desktop"][data-type="rangeFilter"]:checked').each(function(index, input) {
							var name = input.name;
							if (input.name.split('tab-').length > 1) {
								name = input.name.split('tab-')[1];
							}
							if( !rangeFilter[name] )
									rangeFilter[name] = [];
	
							if( input.value ) {
									rangeFilter[name].push(input.value);
							}
						});
					}
				} else {
					$elements.filter('[data-type="rangeFilter"]:checked').each(function(index, input) {
          if( !rangeFilter[input.name] )
            rangeFilter[input.name] = [];

          if( input.value ) {
            rangeFilter[input.name].push(input.value);
          }
    	    });
				}

    Object.keys(rangeFilter).forEach(function(value) {
      if( rangeFilter[value] ) {
        var item = {};
        item[value] = rangeFilter[value];
        payload.rangeFilter.push(item);          
      }
    });
    $elements.filter('input[data-type="availabilityFilter"][data-checked="true"]').each(function(index,input) {
       payload.filter = $(input).val() === "true" ? true : false;
    });
    $elements.filter('input[data-type="availability-filters"]').each(function(index,input) {
       payload.showAvailableHotels = input.checked ? true : false;
    });
    return payload;
  },

  updateFilters: function(event) {
    this.$el.find(this.options.SORT_AND_FILTER_FROM).css({display: 'none'});

    var _self = this;
    $(window).scrollTop(0);
    var submitPayload = this.serializeForm();
    this.$el.find(_self.options.DISPLAY_ONLY_FORM).find(':input').prop('disabled', true);

    submitPayload.expandedBucketCode = this.expandedBucketCode;
    submitPayload.isFilterPanelExpanded = this.isFilterPanelExpanded;

    if (_self.$el.find('.cta-sort-and-filter').data('searchkey') === true) {
      submitPayload['filterApplied'] = _self.$el.find('.cta-sort-and-filter').data('searchkey').toString();
    }
    
    this.refresh(submitPayload, function() {
      window.$(document).trigger('GLOBAL_ELEMENTS_REINIT.mi-foundation');
      _self.showSortAndFilters();
      submitPayload.selectionOrder = _self.selectedOrder;
      var $submitForm = _self.$el.find(_self.options.SUBMIT_FORM);
      $.each($submitForm[0].elements, function(index, input) {
        if( submitPayload[input.name] && submitPayload[input.name].length )
          input.value = JSON.stringify(submitPayload[input.name])
      });
      $submitForm.find('[name="filter"]').val(submitPayload.filter);
      $('.cta-hide-sort-and-filter').focus();
    }, function(error) {
      window.location.replace(_self.$el.data(Constants.FILTER.ERROR_REDIRECT_URI));
    });
  },

  submitSortBy: function() {
    var submitPayload = this.serializeForm(),
        _self = this;
    submitPayload.selectionOrder = this.selectedOrder;
    var $submitForm = this.$el.find(this.options.SUBMIT_FORM);
    $.each($submitForm[0].elements, function(index, input) {
      if( submitPayload[input.name] && submitPayload[input.name].length ) {
        input.value = JSON.stringify(submitPayload[input.name])
      }
    });
    $submitForm.find('[name="filter"]').val(submitPayload.filter);
    $submitForm.submit();
  },

  /**
   * CTA handler for On Accordion Open
   */
  onAccordionOpen: function(evt) {
    var _self = this;
    var $acord = $(evt.currentTarget), $target = $(evt.target);
    if($target.closest('.js-brand-icon').hasClass('js-disabled-brand')){
      return false;
    }
    if( $acord.find('.t-icon-arrow-up').length ) {
      this.expandedBucketCode = $acord.find('.l-toggle-list').data('code');
    }
    _self.toggleHandler($acord);
  },
  /**
   * Toggle handler for Accordion
   */
  toggleHandler: function(toggleContainer) {
    toggleContainer.toggleClass('open');
    if (toggleContainer.hasClass('open')) {
      toggleContainer.find('.js-accordion-section').slideDown('fast', function() {
          $(this).css('overflow', 'visible');
      });
    } else {
      toggleContainer.find('.js-accordion-section').slideUp('fast');
    }
    toggleContainer.find('.t-caption-icon').toggleClass('t-icon-arrow-up').toggleClass('t-icon-arrow-down');
  },
  /**
   * CTA handler for On Accordion Open
   */
  adaAccordionOpen: function(evt) {
    var _self = this;
    var $acord = window.$(evt.currentTarget);
    var charCode = evt.charCode || evt.which;
    if( 13 === charCode ) {
      $acord.trigger('click');
    }
  },

  /**
   * CTA for reset button
   */
  resetForm: function() {
    var $elements = $(this.$el.find(this.options.DISPLAY_ONLY_FORM)[0].elements);
    $elements.prop('checked', false);
    var $submitForm = this.$el.find(this.options.SUBMIT_FORM);
    $submitForm.find('[name="action"]').val('clearAll');
    this.submitSortBy();
  },
  /*
    CTA for brand icons on desktop
  */
  brandIconClickHandler :  function _brandIconClickHandler (event) {
    var $currentTarget = $(event.currentTarget);
    if(!$currentTarget.data('for')) {
      return;
    }
    event.preventDefault();
    $labelForSelector = $('label[for='+$currentTarget.data('for')+']');
    $labelForSelector.trigger('click');
  },
  brandIconKeypressHandler : function _brandIconKeypressHandler (event) {
    var charCode = event.charCode || event.which;
		if( 13 === charCode ) {
      var _self = this;
      _self.brandIconClickHandler(event);
    }
  },
  /*
    Select all brands from category
  */
  selectAllCategoryLabels : function _selectAllCategoryLabels(event){
    event.preventDefault();
    event.stopPropagation();
    var _self = this;
    var brandList = $(event.currentTarget).closest('.l-brand-category').find('.js-brand-icon:not(.js-disabled-brand)');
    brandList.each(function(index,element){
      var elIdContent = $(element).data('for') || $(element).attr('for');
      if(brandList.length-1==index){
        _self.$el.find('#' + elIdContent).prop('checked', false);
        _self.$el.find('label[for=' + elIdContent + ']').trigger('click');
      }else{
        var input = _self.$el.find('#' + elIdContent);
        if(!input.prop('checked')){
          _self.selectedOrder.push(
            {'bucketName': input[0].name, 'code': input[0].value, 'label': _self.$el.find('[for="' + input[0].id + '"]').text().trim() }
          );
          input.prop('checked', true);
        }
      }
    });
  },
    /*
      Clear all brands from category
    */
  clearAllCategoryLabels : function _clearAllCategoryLabels(event){
    event.preventDefault();
    event.stopPropagation();
    var _self = this,
    elementIndex=0,
    input={},
    brandList = $(event.currentTarget).closest('.l-brand-category').find('.js-brand-icon:not(.js-disabled-brand)');
    brandList.each(function(index,element){
      var elIdContent = $(element).data('for') || $(element).attr('for');
      if(brandList.length-1==index){
        _self.$el.find('#' + elIdContent).prop('checked', true);
        _self.$el.find('label[for=' + elIdContent + ']').trigger('click');
      }else{
        input = _self.$el.find('#' + elIdContent);
        if(input.prop('checked')){
         _self.selectedOrder.find(function(obj,index){
            if(obj.code == input[0].id){
              elementIndex = index;
            }
         });
        }
        _self.selectedOrder.splice(elementIndex,1);
        input.prop('checked', false);
      }
    });
  },

		/**
	 * Event handler for sort dropdown value selection
	 */
	onFilterDropdownMenuItemSelected: function(evt) {
		var $menuOption = $(evt.currentTarget);
		if( !$menuOption.hasClass('current-value') ) {
			var paramName = $menuOption.parents('.m-dropdown').data('name');
			var value = $menuOption.data('value');
			this.setFilter(paramName, value);
		}
		this.hideMenu($menuOption);
	},
	/**
	 * Update the filter value in the query params
	 */
	setFilter: function(name, value) {
		var location = window.location;
		var queryParams = {};
		if( location.search ) {
			location.search.substr(1).split('&').forEach(function findParam(param) {
				var params = param.split('=');
				queryParams[params[0]] = params[1]
			})
		}
		queryParams[name] = value;
		
		var filterDropdownUrl = window.location.origin + this.refinedSearchUrl + '?';
		var userAgentDetails = window.navigator.userAgent;
		var ieBrowser = userAgentDetails.indexOf("MSIE ");

		if (ieBrowser > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./))  // If Internet Explorer, return version number
		{
			var actualUrl = window.location.href;
			var refinedUrl = '';
			for (let i = 0; i < Object.entries(queryParams).length; i++) {
				refinedUrl = this.setIEUrl(actualUrl, Object.entries(queryParams)[i][0], Object.entries(queryParams)[i][1]);
				actualUrl = refinedUrl;
			}
			window.location = refinedUrl;
		}
		else  // If another browser, return 0
		{
			var filterurl = new URL(filterDropdownUrl);
			for (let i = 0; i < Object.entries(queryParams).length; i++) {
				filterurl.searchParams.set(Object.entries(queryParams)[i][0], Object.entries(queryParams)[i][1]);
			}
			window.location = filterurl.href;
		}
	},

  /**
   * Method to show suggested pills only on list view
   */
  srpViewChanged: function (selectedView) {
    if (!this.isMobile) {
      if(selectedView === 'map'){
        $('.sort-filter').addClass('sort-filter-map-view');
        $('.currency-filter').addClass('sort-filter-map-view');
      }
      if(selectedView === 'list'){
        $('.sort-filter').removeClass('sort-filter-map-view');
        $('.currency-filter').removeClass('sort-filter-map-view');
      }
    }
    
    if(!this.isSearchFiltersEnabled){
      if (selectedView !== Constants.SRP_VIEW.LIST) {
        this.$el.hide();
      } else {
        if(this.$el.find('ul.l-pill-container li').length == this.$el.find('ul.l-pill-container li.hidden').length) {
          this.$el.hide();
        } else {
          this.$el.show();
        }
        // Fix to avoid sticky MI SLIDER
        $(document).resize();
      }
    }
  },
  submitSuggestedFilterPayload: function (event) {
    var payload = {
      selectionOrder: [],
      rangeFilter: [{ 'price': [] }, { 'distance': [] }],
      facets: [],
      action: this.$el.find('input[name=action]').val(),
      showAvailableHotels: this.$el.find('input[name=showAvailableHotels]').val(),
      isHotelsNearMe: this.$el.find('input[name=isHotelsNearMe]').val()
    },
    selectedFilters = [];
    $target = $(event.currentTarget);
    
    // Return control if count is zero
    if($target.data('count') == 0) {
      return false;
    }
    
    // toggle selected class
    $target.toggleClass('selected');

    // Let's take out all the selected filters in a list
    this.$el.find('a.l-pill').each(function () {
      var isSelected = $(this).hasClass('selected');
      if (isSelected) {
        selectedFilters.push($(this));
      }
    });

    selectedFilters.forEach(function (filterElem) {
      var data = filterElem.data();

      if (data.filtertype == 'facet') {
        payload.selectionOrder.push({
          'bucketName': data.filterkey,
          'code': data.code,
          'label': data.label + ' ' + '('+ data.count +')'
        });
      } else {
        if (data.filterkey == 'price') {
          payload.rangeFilter[0]['price'].push(data.code + '');
        } else {
          payload.rangeFilter[1]['distance'].push(data.code + '');
        }
      }
    });

    // Creating facets array
    payload.facets = [payload.selectionOrder.reduce(function(facets, filter) {
      if(!facets[filter.bucketName]) {
        facets[filter.bucketName] = [];
      }
      facets[filter.bucketName].push(filter.code);
      return facets;
    }, {})];


    // Let's submit the form
    this.$el.find('input[name="selectionOrder"]').val(JSON.stringify(payload.selectionOrder));
    this.$el.find('input[name="rangeFilter"]').val(JSON.stringify(payload.rangeFilter));
    this.$el.find('input[name="facets"]').val(JSON.stringify(payload.facets));
    this.$el.find(this.options.SUGGESTED_FILTER_FORM).submit();
  },
  /**
	 * Update the filter value in the query params
	 */
	toggleAvailableFilter: function(event) {
    if($(event.target).hasClass('available-hotels')){
				var inputElem = $(event.target);
    } else {
      var inputElem = this.$el.find('.available-hotels');
    }
		var fullPriceLabel = this.$el.find('.toggle-full-price').data('full-price'),
		queryParams = {};
		if( window.location.search ) {
			window.location.search.substr(1).split('&').forEach(function findParam(param) {
				var params = param.split('=');
				queryParams[params[0]] = params[1];
			});
    }
    if($(event.target).hasClass('available-hotels')) {
      if($(event.target).hasClass('selected')){
        queryParams[inputElem.data('filter')] = false;
      }
      else {
        queryParams[inputElem.data('filter')] = true;
      }
    } else {
					queryParams[fullPriceLabel] = event.target.checked;
				}
		queryParams['page'] ? queryParams['page'] = 1 : '';
		
		var filterDropdownUrl = window.location.origin + this.$el.data('refine-search-url') + '?';
		var userAgentDetails = window.navigator.userAgent;
		var ieBrowser = userAgentDetails.indexOf("MSIE ");

		if (ieBrowser > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./))  // If Internet Explorer, return version number
		{
			var actualUrl = window.location.href;
			var refinedUrl = '';
			for (let i = 0; i < Object.entries(queryParams).length; i++) {
				refinedUrl = this.setIEUrl(actualUrl, Object.entries(queryParams)[i][0], Object.entries(queryParams)[i][1]);
				actualUrl = refinedUrl;
			}
			window.location = refinedUrl;
		}
		else  // If another browser, return 0
		{
			var filterurl = new URL(filterDropdownUrl);
			for (let i = 0; i < Object.entries(queryParams).length; i++) {
				filterurl.searchParams.set(Object.entries(queryParams)[i][0], Object.entries(queryParams)[i][1]);
			}
			window.location = filterurl.href;
		}
	},

  setIEUrl: function(url, key, val) {
		var reExp = new RegExp("[\?|\&]"+ key + "=[0-9a-zA-Z\_\+\-\|\.\,\;]*");
		if(reExp.test(url)) {
			// update
			var reExp = new RegExp("[\?&]" + key + "=([^&#]*)");
			var delimiter = reExp.exec(url)[0].charAt(0);
			url = url.replace(reExp, delimiter + key + "=" + val);
		} else {
			// add
			var newParam = key + "=" + val;
			if(!url.indexOf('?')){url += '?';}
			if(url.indexOf('?') > -1){
				var urlparts = url.split('#');
				url = urlparts[0] +  "&" + newParam +  (urlparts[1] ?  "#" +urlparts[1] : '');
			} else {
				url += "?" + newParam;
			}
		}
		//window.location = url;
		return url;
	},

	/**
	* Device Mode Handler
	*/
	initDeviceMode: function _initDeviceMode() {
    var _self = this;
    if (window.matchMedia('(max-width: '+ Constants.GLOBAL.MOBILE_VIEWPORT +'px)').matches) {
      _self.isMobile = true;
    } else {
      _self.isMobile = false;
    }
		$(window).on('resize', function() {
			if (window.matchMedia('(max-width: '+ Constants.GLOBAL.MOBILE_VIEWPORT +'px)').matches) {
				_self.isMobile = true;
			} else {
				_self.isMobile = false;
			}
		});
	},

		toggleClass: function _toggleClass(otherElems, thisELem, className = 'is-active') {
			for (const otherElem of otherElems) {
				otherElem.classList.remove(className);
			}
			thisELem.classList.add(className);

			if (thisELem.dataset && thisELem.dataset.code && thisELem.dataset.code !== undefined && thisELem.dataset.code !==  null) {
				this.expandedBucketCode = thisELem.dataset.code;
			}
		},
		toggleVerticalTabs : function _toggleVerticalTabs(tabContainer, tabs, items, item) {
			const __self = this;
			item.onclick = function (e) {
				const currId = item.getAttribute('id');
				const tab = tabContainer.querySelector(
					'.l-tabcontainer-tabs [aria-controls="' + currId + '"]'
				);
				__self.toggleClass(tabs, tab);
				__self.toggleClass(items, item);
			};
		},
		toggleTabs : function _toggleTabs(tabContainer) {
			const tabs = tabContainer.querySelectorAll('.l-tabcontainer-tabs .l-tabcontainer-tab');
			const items = tabContainer.querySelectorAll('.l-tabcontainer-content');
			const __self = this;
		
			for (const tab of tabs) {
				tab.onclick = function () {
					const target = tab.getAttribute('aria-controls');
					const content = document.getElementById(target);
					__self.toggleClass(tabs, tab);
					__self.toggleClass(items, content);
				};

				tab.onkeydown = function (e) {
					if (e.keyCode === 13) {
						const target = tab.getAttribute('aria-controls');
						const content = document.getElementById(target);
						__self.toggleClass(tabs, tab);
						__self.toggleClass(items, content);
					}
				}
			}
			for (const item of items) {
				__self.toggleVerticalTabs(tabContainer, tabs, items, item);
			}
		},
		hasTabs: function _hasTabs(container) {
			return container.classList.contains('has-tabs');
		},
		initTabs: function _initTabs() {
			const tabContainers = document.querySelectorAll('.l-tabcontainer');
			for (const tabContainer of tabContainers) {
				this.toggleTabs(tabContainer);
			}
		},
    /**
     * toggle footer on all filter opening for hotel directory view
     */
     toggleFooterFilter: function(showFooter) {
      var footer = $('.m-footer');
      showFooter ? footer.show(): footer.hide();
    }
}));
